import { useEffect } from 'react';
import LegalPageLayout from './LegalPageLayout';
import { PRIVACY_IT } from '../../data/legal/it/privacy';

export default function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = `${PRIVACY_IT.titolo} · Marketplace FV`;
  }, []);
  return <LegalPageLayout doc={PRIVACY_IT} />;
}
